import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import alertify from "alertifyjs";
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { ErrorDialogComponent } from 'src/app/Shared/shared/error-dialog/error-dialog.component';
import {AuthService} from "../../../../Services/auth.service";

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  form: any = FormGroup;
  isLoading: boolean;
  details: any;

  constructor(
    private apiService: ApiServiceService,
    private bsModalService: BsModalService,
    private authService: AuthService,
    private fb: FormBuilder

  ) { }

  ngOnInit(): void {

    this.initializeForm()

  }

  initializeForm() {

    this.form = this.fb.group({

      verificationType: ['', [Validators.required]],
      id: ['', [Validators.required]],

    });

  }

  submit() {

    this.isLoading = true
  
    const type: string = this.form.get("verificationType")?.value
    const id: string = this.form.get("id")?.value

  const dto = {
    id: id,
    type: type
  }
  
    const url = '/assessments/document/verifications';
  
  
    this.details = {}
  
  
    this.apiService.post(url, dto).subscribe(
      (response) => {
  
        if (response?.data != null) {
  
          this.details = response?.data;
  
          this.isLoading = false
  
        } 
  
        if(this.details?.message == 'Not Found!'){
  
          this.confirmAfterError('Not Found!');
  
        }
      },
      (error) => {
        this.isLoading = false
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
  
      }
    );
  
  }

  confirmAfterError(message: any) {
    let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }
  hasAccess(permissions:string[]){
    return this.authService.hasAnyPermission(permissions)
  }
}